import { createSlice } from "@reduxjs/toolkit";
const gallerySlice = createSlice({
    name: 'gallery',
    initialState: {
        gallery: [
          
        ]
    },

    reducers: {
        updateGallery : (state, action) => {
            state.gallery = action.payload
        }
    }
});

export const {updateGallery} = gallerySlice.actions;
export default gallerySlice.reducer;